import { Component } from 'react'
import { Redemption } from 'interfaces/bounty'
import { TableContextType, TableContext } from 'components/molecules/tables/Table2'
import * as styles from 'components/features/pfm/RedemptionsModule/RedemptionsModuleRowMobile.css'
import AccountBadge from 'components/features/pfm/AccountBadge/AccountBadge'
import { formatUSCurrency } from 'helpers/formatHelpers'
import TableNoWrapValue from 'components/atoms/tables/TableNoWrapValue'
import withContext from 'hocs/withContext/withContext'

type RowMobileProps = {
  table: TableContextType
  row: Redemption
}

class RedemptionsModuleRowMobile extends Component<RowMobileProps> {
  render () {
    const { row } = this.props
    const {
      date,
      account,
      amount,
    } = row

    const rowKey = this.props.table.getRowKey(row)

    return (
      <tr key={ rowKey }>
        <td>
          <div className={ styles.redemptionsModuleRowMobile }>
            <AccountBadge
              name={ account.name }
              cardNumber={ account.account_number4 }
              updatedAt={ date }
              updatedAtPrefix='on'
            />
            <div className={ styles.amount }>
              <TableNoWrapValue>{ formatUSCurrency(amount, 'penny') }</TableNoWrapValue>
            </div>
          </div>
        </td>
      </tr>
    )
  }
}

export default withContext(TableContext, 'table')(RedemptionsModuleRowMobile)
